/**
 * File: mobile-menu.js
 *
 * Create an accordion style dropdown.
 */

/* eslint-disable no-console */
// Make sure everything is loaded first.
const toggleMenu = ( e ) => {
	const el = document.querySelector( '.menu-trigger' );
	const menu = document.querySelector( '.main-nav' );

	console.log( e );

	if ( el.classList.contains( 'active' ) ) {
		el.classList.remove( 'active' );
		menu.classList.remove( 'open' );
	} else {
		el.classList.add( 'active' );
		menu.classList.add( 'open' );
	}
};

document
	.querySelector( '.menu-trigger' )
	.addEventListener( 'click', toggleMenu );

// const deactivateCheckbox = ( event ) => {
// 	const el = event.target;
// 	console.log( event );
// 	el.classList.remove( 'checked' );
// 	// el.removeEventListener( 'click', deactivateCheckbox );
// 	// el.addEventListener( 'click', activateCheckbox );
// };
const activateCheckbox = ( event ) => {
	const el = event.target;
	el.classList.add( 'checked' );
	// el.removeEventListener( 'click', activateCheckbox );
	// el.addEventListener( 'click', deactivateCheckbox );
};

document.querySelectorAll( '.checkbox' ).forEach( ( el ) => {
	console.log( el );
	el.addEventListener( 'click', activateCheckbox );
} );
/* eslint-enable no-console */
